import actions from '../action/enterprise'
import CONSTANT from '../constant/enterprise'

const recommend = []
const totalCount = 0
const cards = []
const pageNum = 0
const hasNoCard = false
const isNoMore = false
const enterpriseBillboardList = []
const enterpriseShopList = []

export default {
  actions,
  state: {
    recommend,
    cards,
    pageNum,
    hasNoCard,
    isNoMore,
    enterpriseBillboardList,
    enterpriseShopList,
  },
  mutations: {
    [CONSTANT.ENTERPRISE_GET_CARD_SUCCESS] (state, data = {}) {
      state.cards = state.cards.concat(data.data || [])
      state.pageNum = data.pageNum
      if (state.cards.length === 0 && data.data.length === 0) {
        state.hasNoCard = true
      }
    },
    [CONSTANT.ENTERPRISE_INIT_CARDS] (state) {
      state.cards = []
      state.pageNum = pageNum
      state.hasNoCard = hasNoCard
      state.isNoMore = isNoMore
    },
    [CONSTANT.ENTERPRISE_SET_CURRENT_PAGEINDEX] (state, pageNum) {
      state.currentPageNum = pageNum
    },
    [CONSTANT.ENTERPRISE_GET_CARD_NOMORE_STATUS] (state) {
      if (state.cards.length > 0) {
        return state.isNoMore = true
      }
      return state.hasNoCard = true
    },
    [CONSTANT.ENTERPRISE_GET_CARD_ERROR] (state) {
    },
    [CONSTANT.ENTERPRISE_GET_RECOMMEND_SUCCESS] (state, data) {
      return state.recommend = data
    },
    [CONSTANT.ENTERPRISE_GET_RECOMMEND_ERROR] (state) {
      return state.recommend = []
    },
    [CONSTANT.ENTERPRISE_BILLBOARDS_GET_LIST_SUCCESS] (state, result) {
      return state.enterpriseBillboardList = result
    },
    [CONSTANT.ENTERPRISE_BILLBOARDS_GET_LIST_ERROR] (state, e) {
      return state.enterpriseBillboardList = []
    },
    [CONSTANT.ENTERPRISE_SHOPS_GET_LIST_SUCCESS] (state, result) {
      return state.enterpriseShopList = result
    },
    [CONSTANT.ENTERPRISE_SHOPS_GET_LIST_ERROR] (state, e) {
      return state.enterpriseShopList = []
    }
  },
  getters: {
    hasNoCard(state) {
      return state.hasNoCard
    }
  }
}
